<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import socket from "@/utils/socket";
import store from "@/store";
import {EventBus} from "@/utils/eventBus"

export default {
  name: 'App',
  mounted() {
    this.freshuserinfo()
  },
  created() {
    // 创建连接
    this.socket = new socket("wss://lxf.yxjky.com/ws?platform=7", {
      onOpen: () => {
        console.log("连接成功")
      },
      onClose: () => {
        console.log("连接关闭")
      },
      onError: (err) => {
        console.error("连接出错", err)
      }
    })
    // 绑定自定义消息事件
    this.socket.on("init", (message) => {
      store.commit('user/SET_CLIENT_ID', message.client_id)
      const token = this.$utils.getToken()
      if (token) {
        this.socket.send({
          type: "login",
          platform: 7,
          token: token
        })
      }
    })
    // 建立连接
    this.socket.connect()
    EventBus.$on('wsSendMsg', (msg) => {
      console.log('wsSendMsg', msg)
      if (this.socket && this.socket.send) {
        this.socket.send(msg)
      }
    })

    try {
      // 初始化全屏
      if (nw) {
        const win = nw.Window.get()
        win.maximize()
      }
    } catch (e) {

    }


  },
  beforeDestroy() {
    // 关闭连接
    if (this.socket) {
      this.socket.close()
    }
  },
  methods: {
    sendMessage() {
      this.socket.send({
        event: "chat",
        message: "Hello Server"
      })
    },
    freshuserinfo() {
      const userinfo = localStorage.getItem("userInfo")
      if (userinfo) {
        this.$store.commit('user/SET_USER_INFO', JSON.parse(userinfo))
      }
    }
  }
}
</script>

<style lang="scss">
@import './common/css/common.scss';

body {
  font-family: -apple-system, BlinkMacSystemFont, "San Francisco", "Helvetica Neue", sans-serif;
  margin: 0;
  padding: 0;
}

#app {
}
</style>
